var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import * as Sentry from '@sentry/react';
export function useAsyncData(_a) {
    var _this = this;
    var selector = _a.selector, method = _a.method, service = _a.service, _b = _a.invokeOnMount, invokeOnMount = _b === void 0 ? true : _b, defaultValue = _a.defaultValue, suppressToast = _a.suppressToast;
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var _c = useState(invokeOnMount), isLoading = _c[0], setIsLoading = _c[1];
    var _d = useState(defaultValue), data = _d[0], setData = _d[1];
    var _e = useState(), error = _e[0], setError = _e[1];
    var invoke = useCallback(function () {
        var x = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            x[_i] = arguments[_i];
        }
        return __awaiter(_this, void 0, void 0, function () {
            var method2, response, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setError(undefined);
                        setIsLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        method2 = method.bind(service);
                        return [4 /*yield*/, method2.apply(void 0, (x.length ? x : args))];
                    case 2:
                        response = _a.sent();
                        setData(selector ? selector(response) : response);
                        return [2 /*return*/, response];
                    case 3:
                        e_1 = _a.sent();
                        // dispose old data
                        setData(defaultValue);
                        if (e_1 instanceof Error) {
                            setError(e_1);
                        }
                        else {
                            setError(new Error('An error occurred'));
                        }
                        throw e_1;
                    case 4:
                        setIsLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }, __spreadArray([method, service], args, true));
    useEffect(function () {
        if (error && !suppressToast) {
            toast.error(error.message || error.name);
        }
    }, [error, suppressToast]);
    useEffect(function () {
        if (invokeOnMount) {
            invoke.apply(void 0, args).catch(function (e) {
                if (Sentry.isInitialized()) {
                    Sentry.captureException(e);
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, __spreadArray([invoke], args, true));
    return { isLoading: isLoading, data: data, error: error, invoke: invoke };
}
